import { motion, useScroll, useTransform } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export const ParallaxReveal = ({ children, direction = "left", parallaxOffset = 30 }) => {
    const ref = useRef(null);

    // Scroll-basierter Parallax-Effekt
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });

    const y = useTransform(scrollYProgress, [0, 1], ["0px", `-${parallaxOffset}px`]);

    // Animations-Variants
    const variants = {
        hidden: {
            x: direction === "left" ? -100 : 100,
            opacity: 0,
        },
        visible: {
            x: 0,
            opacity: 1,
            transition: {
                duration: 0.8,
                ease: "easeOut",
            },
        },
    };

    return (
        <div style={{ overflow: 'hidden' }}>

            <motion.div
                ref={ref}
                style={{ y }}
                variants={variants}
                initial="hidden"
                exit="hidden"
                whileInView="visible"
                transition={{ type: "tween", duration: 0.4, ease: "easeOut" }} // für normales Scrollverhalten
                viewport={{ once: false, amount: 0.2 }}
            >
                {children}
            </motion.div>
        </div>
    );
};


// 2. ParallaxImage mit stärkerem Y-Parallax (ohne Slide-In)
export const ParallaxImage = ({ src, alt, parallaxOffset = 40, mobileparallaxOffset = 30, className }) => {
    const ref = useRef(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1380);

    useEffect(() => {
        const onResize = () => setIsMobileView(window.innerWidth <= 1380);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(
        scrollYProgress,
        [0, 1],
        ["0px", `-${isMobileView ? mobileparallaxOffset : parallaxOffset}px`]
    );

    return (
        <motion.img
            ref={ref}
            src={src}
            alt={alt}
            style={{ y }}
            className={className}
        // keine initial/animate nötig, nur Parallax
        />
    );
};